import { useState } from 'react'

import moment from 'moment'

import { ListItemIcon, MenuItem } from '@mui/material'
import { Delete, SaveOutlined } from '@mui/icons-material'

import { ConfirmationDialog, Select, IconButton, Tooltip } from '@collaborate-health/uikit'

import { getFormTitle } from '@tabeeb/modules/appConfigState/selectors'
import { useDispatch, useSelector } from '@tabeeb/store'

import {
  getCurrentForm,
  getFormRecordsList,
  getIsDeleteFormRecordButtonVisible,
  getIsFormRecordAreaVisible,
  getIsSaveFormRecordButtonVisible,
} from '@tabeeb/modules/forms/selectors'
import { apiRemoveFormRecord, saveFormRecord, setSelectedRecord } from '@tabeeb/modules/forms/actions'
import { getCurrentUserId } from '@tabeeb/modules/account/selectors'
import { ContentFormRecordType } from '@tabeeb/enums'

const FormRecords: React.FC = () => {
  const dispatch = useDispatch()

  const [selectedRecordForDelete, setSelectedRecordForDelete] = useState<number>()
  const formTitle = useSelector(getFormTitle)

  const showRecords = useSelector(getIsFormRecordAreaVisible)
  const isSaveButtonVisible = useSelector(getIsSaveFormRecordButtonVisible)
  const isDeleteButtonVisible = useSelector(getIsDeleteFormRecordButtonVisible)
  const records = useSelector(getFormRecordsList)
  const form = useSelector(getCurrentForm)
  const currentUserId = useSelector(getCurrentUserId)

  const selectedRecord = useSelector((state) => state.forms.currentForm.selectedRecord) || 0
  const recordSavingInProgress = useSelector((state) => state.forms.recordSavingInProgress)

  const _handleDeleteFormRecord = () => {
    dispatch(apiRemoveFormRecord.request(selectedRecordForDelete!))
    setSelectedRecordForDelete(undefined)
  }

  if (!showRecords) {
    return null
  }

  return (
    <>
      <Select
        size='small'
        value={selectedRecord}
        onChange={(e) => dispatch(setSelectedRecord(parseInt(e.target.value as string, 10)))}
        renderValue={(value) => {
          if (value === 0) {
            return 'Current view'
          }

          const record = records.find((r) => r.Id === value)
          if (!record) {
            return 'Unknown record'
          }

          return moment(record.CreatedOn).format('MMM D, YYYY h:mm A')
        }}
      >
        <MenuItem value={0}>Current view</MenuItem>
        {records.map((record) => (
          <MenuItem value={record.Id} key={record.Id}>
            {isDeleteButtonVisible && (
              <ListItemIcon>
                <IconButton
                  color='error'
                  size='small'
                  title='Delete record'
                  onClick={(e) => {
                    e.stopPropagation()

                    setSelectedRecordForDelete(record.Id)
                  }}
                >
                  <Delete fontSize='small' />
                </IconButton>
              </ListItemIcon>
            )}

            {moment(record.CreatedOn).format('MMM D, YYYY h:mm A')}
          </MenuItem>
        ))}
      </Select>

      {isSaveButtonVisible && (
        <Tooltip text='Save record'>
          <span>
            <IconButton
              disabled={recordSavingInProgress || selectedRecord > 0}
              color='primary'
              shape='rectangular'
              variant='outlined'
              onClick={() =>
                dispatch(
                  saveFormRecord.request({
                    contentFormId: form.Id!,
                    userId: currentUserId,
                    type: ContentFormRecordType.Manual,
                  })
                )
              }
            >
              <SaveOutlined />
            </IconButton>
          </span>
        </Tooltip>
      )}

      <ConfirmationDialog
        isOpen={!!selectedRecordForDelete}
        title={`${formTitle} record will be permanently deleted.`}
        submitButtonColor='error'
        submitButtonText='Delete'
        onCloseDialog={() => setSelectedRecordForDelete(undefined)}
        onSubmit={_handleDeleteFormRecord}
      />
    </>
  )
}

export default FormRecords

